let analyzeOptions = {
	// tooltip: {
	// 	trigger: 'axis'
  // },
	itemStyle:{
	  barBorderRadius: 10,  
	},
	legend: {
		selectedMode: true,
		textStyle: {
			color: '#92b1d8',
		},
		bottom: '0',
		x: 'center',
		data: ['职能', '行业']
	},
	grid: {
		top: '6%',
		left: '2%',
		right: '2%',
		bottom: '10%',
		containLabel: true
	},
  calculable: false,
	xAxis: [{	
		data: ['操作执行层', '初级专员层', '专员层', '主管层', '经理层', '总监层', '决策层']
	}],
	yAxis: [{	
    type: 'value',
    splitLine:{
      　　　　show:false
      　　 }
	}],
	series: [
		{
			barWidth: 6,
			type: 'bar',
			stack: '职能',
			name: '最低值',
			itemStyle: {
				normal: {
					barBorderColor: 'rgba(0,0,0,0)',
					color: 'rgba(0,0,0,0)'
				},
				emphasis: {
					barBorderColor: 'rgba(0,0,0,0)',
					color: 'rgba(0,0,0,0)'
				}
			},
			data: [2000, 1.9, 29.0, 16.4, 18.7, 70.7, 55.6],
		},
		{
			barWidth: 6,
			type: 'bar',
			stack: '行业',
			name: '最低值',
			itemStyle: {
				normal: {
					barBorderColor: 'rgba(0,0,0,0)',
					color: 'rgba(0,0,0,0)'
				},
				emphasis: {
					barBorderColor: 'rgba(0,0,0,0)',
					color: 'rgba(0,0,0,0)'
				}
			},
			data:  [3000, 15.9, 19.0, 19.4, 28.7, 70.7, 35.6],
		},
		{
			barMinHeight: 2,
			barWidth: 6,
			barGap: 2,
			stack: '职能',
			name: '职能',
      type: 'bar',      
      data: [4000, 44, 55, 16, 42, 23, 9],
      itemStyle: {
				normal: {
					barBorderColor: '#0bc8f4',
					color: '#0bc8f4'
				},
				emphasis: {
					barBorderColor: '#0bc8f4',
					color: '#0bc8f4'
				}
			},		
		},
		{
			barMinHeight: 2,
			barWidth: 6,
			barGap: 2,
			stack: '行业',
			name: '行业',
			type: 'bar',
			data: [3200, 47, 50, 26, 42, 28, 39],
			itemStyle: {
				normal: {
					barBorderColor: '#F56C6C',
					color: '#F56C6C'
				},
				emphasis: {
					barBorderColor: '#F56C6C',
					color: '#F56C6C'
				}
			}
		}
	]
};
export default analyzeOptions;